import type { ScoreBand } from '@/types/insights';
import { colorForBand } from '@/components/map/scoreColor';
import { round } from '@/utils/numbers';

interface MetricCardProps {
  title: string;
  band: ScoreBand;
  suffix?: string;
  /** Plain-language explanation shown in a hover/focus tooltip off the (i) icon. */
  helpText?: string;
}

export function MetricCard({ title, band, suffix = '', helpText }: MetricCardProps) {
  const isInsufficient = band.label === 'insufficient-data';
  return (
    <div className="metric-card">
      <div className="metric-card__title-row">
        <div className="metric-card__title">{title}</div>
        {helpText && (
          <span className="metric-card__info" tabIndex={0} aria-label={`What ${title} means`}>
            i
            <span className="metric-card__tooltip" role="tooltip">
              {helpText}
            </span>
          </span>
        )}
      </div>
      <div className="metric-card__value" style={{ color: isInsufficient ? '#94a3b8' : colorForBand(band) }}>
        {isInsufficient ? 'N/A' : `${round(band.value, 0)}${suffix}`}
      </div>
      <div className="metric-card__label">{isInsufficient ? 'Not enough data' : band.label}</div>
    </div>
  );
}
